import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { AttachSVG } from "./AttachSVG";
import FileList from "./FileList";
import { fileToBase64 } from "@/utils/FileToBase64";
import { useDeviceContext } from "@/context/deviceContext/deviceContext";

const fileTypes = ["PDF"];

const FileUpload = ({ incomeView, uploadedFiles, deleteFile, uploadFile }) => {
  const [file, setFile] = useState(null);
  const handleChange = async (file) => {
    if (
      uploadedFiles.length >= 4
      // &&
      // uploadedFiles?.find(
      //   (doc: any) => doc.documentTypeId === content.docType && doc.fileContentId
      // )
    ) {
      alert(`Превышено максимальное количество файлов.
Максимальное количество - 4.`);
      return;
    }
    setFile(file);
    console.log({ uploadedFile: file });
    fileToBase64(file).then((result) => {
      uploadFile(result, file, setFile);
    });
  };

  const { isMobile } = useDeviceContext();

  const Upload = (
    <Box
      sx={(theme) => ({
        padding: "24px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderRadius: "8px",
        border: "1px dashed  #D5D5D6",
        background: "#F8F8F8",
        cursor: "pointer",
        [theme.breakpoints.down("sm")]: {
          padding: "24px 16px",
          textAlign: "center",
        },
      })}
    >
      {isMobile ? (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <AttachSVG />
          <Typography
            sx={(theme) => ({
              color: "#27AE60",
              fontSize: "12px",
              fontWeight: "400",
              lineHeight: "16px",
            })}
          >
            загрузите с телефона
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={(theme) => ({
              color: "#808185",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "22px",
              marginRight: "8px",
            })}
          >
            Перетащите справку с другого банка о доходах сюда или
          </Typography>
          <AttachSVG />
          <Typography
            sx={(theme) => ({
              color: "#27AE60",
              fontSize: "12px",
              fontWeight: "400",
              lineHeight: "16px",
            })}
          >
            загрузите с компьютера
          </Typography>
        </Box>
      )}
      <Typography
        sx={(theme) => ({
          color: "#AAABAD",
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "18px",
          marginTop: "5px",
        })}
      >
        Справка на дату подачи заявки, за последние 12 месяцев с разбивкой по
        месяцам или за период налоговой декларации
      </Typography>
    </Box>
  );
  return (
    <Box>
      <FileUploader
        handleChange={handleChange}
        name="file"
        types={fileTypes}
        children={Upload}
      />
      <FileList
        uploadedFiles={uploadedFiles as any}
        deleteFile={deleteFile}
        file={file}
      />
    </Box>
  );
};

export default FileUpload;
